import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, RouteRefreshComponent } from './shared';
import { ChatPageComponent } from './shared/components/chat-page/chat-page.component';

export const routes: Routes = [
  {
    path: '',
    component: RouteRefreshComponent,
    pathMatch: 'full'
  },
  {
    // Pusty przystanek przy przejściu z okna alarmu do innego alarmu — zamyka stare okno,
    // nic nie wyświetla i (inaczej niż '') nikąd nie przekierowuje.
    path: 'alarm-switch',
    children: []
  },
  {
    path: 'chat',
    component: ChatPageComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: 'ROLE_API_CAREGIVER', notForObserver: true, event: 'EVENTS.SCREEN.CHAT' }
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'indiv-client',
    loadChildren: () => import('./indiv-client/indiv-client.module').then(m => m.IndivClientModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'help',
    loadChildren: () => import('./help/help.module').then(m => m.HelpModule)
  },
  {
    path: 'start',
    loadChildren: () => import('./start/start.module').then(m => m.StartModule)
  },
  {
    path: 'caregivers',
    loadChildren: () => import('./caregivers/caregivers.module').then(m => m.CaregiversModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'my-dashboard',
    loadChildren: () => import('./my-dashboard/my-dashboard.module').then(m => m.MyDashboardModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'caretaker',
    loadChildren: () => import('./caretaker/caretaker.module').then(m => m.CaretakerModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'manager',
    loadChildren: () => import('./manager/manager.module').then(m => m.ManagerModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'voip',
    loadChildren: () => import('./voip/voip.module').then(m => m.VoipModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canLoad: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
